var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import produce from 'immer';
import { GET_USERS_REQUEST, GET_USERS_SUCCESS, GET_USERS_FAILURE, SELECT_USER, QUERY_USERS, SELECT_ALL_USERS, INVITE_USER_REQUEST, INVITE_USER_FAILURE, INVITE_USER_SUCCESS, } from './constants';
export var initialState = {
    users: [],
    usersAppId: '',
    meta: {},
    loading: false,
    inviting: false,
    error: '',
    searchQuery: '',
};
function usersInviteReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case GET_USERS_REQUEST:
                state.loading = true;
                state.error = '';
                break;
            case GET_USERS_FAILURE:
                state.loading = false;
                state.error = 'Something went wrong getting users';
                break;
            case GET_USERS_SUCCESS:
                state.users = action.users;
                state.usersAppId = action.usersAppId;
                state.meta = action.meta;
                state.loading = false;
                state.error = '';
                break;
            case QUERY_USERS:
                state.searchQuery = action.searchQuery;
                break;
            case SELECT_USER: {
                var idx = state.users.findIndex(function (u) { return u.id === action.userId; });
                if (idx > -1) {
                    state.users[idx].selected = action.selected;
                }
                break;
            }
            case SELECT_ALL_USERS:
                state.users = state.users.map(function (user) { return (__assign(__assign({}, user), { selected: action.selected })); });
                state.touched = true;
                break;
            case INVITE_USER_REQUEST:
                state.inviting = true;
                state.error = '';
                break;
            case INVITE_USER_FAILURE:
                state.inviting = false;
                state.error = 'Something went wrong inviting members';
                break;
            case INVITE_USER_SUCCESS:
                state.inviting = false;
                state.error = '';
                break;
            default:
                break;
        }
    });
}
export default usersInviteReducer;
